/* global MediaStream */
import React from 'react';

import AudioMeter from '../Videoconference/Helpers/AudioMeter';
import noCameraNurse from '../../assets/images/nocamera-nurse.jpg';
import noCameraDoctor from '../../assets/images/nocamera-doctor.jpg';

export default class WebcamView extends React.PureComponent {

    constructor(props) {
        super(props);
        this.videoRef = React.createRef();
        this.listeners = [];
        this.onTrackEnded = this.onTrackEnded.bind(this);
        this.muted = false;
        this.cameraOff = false;
    }

    async componentDidMount() {
        this.videoObj = this.videoRef.current;
        this.stream = window.sdk.videoconf().mediaDevices().getStream();
        this.updateVideo();

        if ( !this.cameraOff && ( !this.videoObj.srcObject || (!this.videoObj.srcObject.active) ) ) {
            this.cameraOff = true;
            this.forceUpdate();
        }
        if ( this.muted != window.sdk.videoconf().isMicMute() ) {
            this.muted = window.sdk.videoconf().isMicMute();
            this.forceUpdate();
        }
        
        this.listeners.push(window.sdk.event().on('mediaDeviceUpdated', (data) => {
            if (data.kind.startsWith('video')) {
                //this.removeOldTrack();
                this.stream = data.stream;
                this.updateVideo();
            }
        }));

        this.listeners.push(window.sdk.event().on('toggleMic', (data) => {
            this.muted = data;
            this.forceUpdate();
        }));

        this.listeners.push(window.sdk.event().on('toggleWebcam', (data) => {
            this.cameraOff = data;
            this.forceUpdate();
        }));        
        
    }

    onTrackEnded() {
    }

    updateVideo() {
        if (this.stream && this.stream.getVideoTracks().length > 0) {
            this.videoObj.srcObject = new MediaStream([this.stream.getVideoTracks()[0]]);
        }
    }

    removeOldTrack() {
        /*if (!this.videoRef.current.srcObject)
            return;

        const tracks = this.videoRef.current.srcObject.getVideoTracks();
        for (let j in tracks) {
            tracks[j].stop();
        }*/
    }

    componentWillUnmount() {
        //this.removeOldTrack();

        for (var i in this.listeners) {
            this.listeners[i]();
        }
    }

    render() {
        const { noscale, noaudiometer, expandAction, full, audioMeterVertical } = this.props;
        return ( 
            <div className={'video-block' + (full ? ' video-block--full' : '')}>
                {this.muted && <div className="video-block__muted">
                    <i className="icon-mic-off" />
                </div>}
                <video className="video-block__video" playsInline id="webcam-preview" disablePictureInPicture  autoPlay={true} ref={this.videoRef} muted></video> 
                {(!noaudiometer) && <AudioMeter className="video-block__audiometer" meterId={ 'Main' } vertical={audioMeterVertical} />}
                {(!noscale && !full) && <button className="video-block__scale" onClick={expandAction}> 
                    <i className="icon-expand"></i>
                </button>}
                { this.cameraOff && <img src={ window.sdk.session().session.name == 'medecin' ? noCameraDoctor : noCameraNurse} className="video-block__image" /> }
            </div>
        );
    }

}
